/*eslint-disable*/

export const twinkle = function (elList) {
  if(!elList.length) return;
  let arr = ['red','#08d803','yellow'];
  let i = 0;
  let inter = setInterval(() => {
    if(i===3){i=0}
    elList.forEach((item)=>{
      if(item&&item.children[0]){
        item.children[0].style.color = arr[i]
      }
      
    });
    i++
  },1000)
};
export const twinkleTwo = function (elList) {
if(!elList.length) return;
let arr = ['red','yellow'];
let i = 0;
let inter2 = setInterval(() => {
  if(i===2){i=0}
  elList.forEach((item)=>{
    if(item&&item.children[0]){
      item.children[0].style.color = arr[i]
    }
    
  });
  i++
},1000)
};



// WEBPACK FOOTER //
// ./src/pages/build08/assets/js/dom.js